// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   FLIGHT DETAILS MODAL - ПОЛНЫЙ CSS
   Pulkovo Air - Культурные крылья России
   ============================================ */

/* ----- МОДАЛЬНОЕ ОКНО ----- */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: modalFadeIn 0.3s ease;
  padding: 10px;
}

.modal-content {
  background: #ffffff;
  border-radius: 20px;
  max-width: 800px;
  width: 100%;
  max-height: 95vh;
  overflow-y: auto;
  padding: 24px;
  position: relative;
  animation: modalSlideUp 0.3s ease;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

/* Добавляем отступ сверху для контента, чтобы не перекрывался кнопкой */
.modal-content > *:first-child {
  margin-top: 0;
}

/* Скрываем скролл для body при открытом модальном окне */
body.modal-open {
  overflow: hidden;
}

/* ----- КНОПКА ЗАКРЫТИЯ ----- */
.modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.95);
  border: none;
  font-size: 24px;
  color: #1E3A8A;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
  padding: 0;
  border-radius: 50%;
  line-height: 1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
}

.modal-close:hover {
  transform: rotate(90deg) scale(1.05);
  color: #F59E0B;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(245, 158, 11, 0.2);
}

.modal-close:active {
  transform: scale(0.9);
}

/* ----- ЗАГОЛОВОК ----- */
.flight-details-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 2px solid #E5E7EB;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 10px;
}

.flight-number .label {
  font-size: 11px;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: block;
  margin-bottom: 2px;
}

.flight-number .value {
  font-size: 26px;
  font-weight: 700;
  color: #1E3A8A;
  font-family: 'Courier New', monospace;
}

.flight-status {
  flex-shrink: 0;
}

/* ----- СТАТУСЫ ----- */
.status-badge {
  padding: 5px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  display: inline-block;
}

.status-badge.in_air,
.status-badge.in-air {
  background: #FEF3E8;
  color: #F59E0B;
  border: 1px solid #FDE68A;
}

.status-badge.booked {
  background: #EFF6FF;
  color: #1E3A8A;
  border: 1px solid #BFDBFE;
}

.status-badge.completed {
  background: #D1FAE5;
  color: #10B981;
  border: 1px solid #A7F3D0;
}

.status-badge.scheduled {
  background: #F3F4F6;
  color: #6B7280;
  border: 1px solid #E5E7EB;
}

.status-badge.delayed {
  background: #FEF2F2;
  color: #DC2626;
  border: 1px solid #FECACA;
}

.status-badge.cancelled {
  background: #F3F4F6;
  color: #6B7280;
  border: 1px solid #E5E7EB;
  text-decoration: line-through;
}

/* ----- ИНФОРМАЦИЯ О МАРШРУТЕ ----- */
.flight-route-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #F9FAFB;
  border-radius: 16px;
  margin-bottom: 16px;
  border: 1px solid #E5E7EB;
  gap: 10px;
}

.airport-info {
  flex: 1;
  text-align: center;
}

.airport-info .airport-code {
  font-size: 22px;
  font-weight: 700;
  color: #1E3A8A;
  font-family: 'Courier New', monospace;
  letter-spacing: 1px;
}

.airport-info .airport-city {
  font-size: 15px;
  font-weight: 600;
  color: #1F2937;
  margin-top: 2px;
}

.airport-info .airport-name {
  font-size: 12px;
  color: #6B7280;
  margin-top: 2px;
}

.airport-info .airport-label {
  font-size: 10px;
  color: #9CA3AF;
  margin-top: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.airport-info.departure .airport-code {
  color: #1E3A8A;
}

.airport-info.arrival .airport-code {
  color: #F59E0B;
}

.route-arrow {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 15px;
  color: #F59E0B;
  font-size: 20px;
  flex-shrink: 0;
}

.route-arrow .distance {
  font-size: 11px;
  color: #6B7280;
  margin-top: 2px;
  font-weight: 500;
}

.route-arrow i {
  animation: arrowPulse 2s ease-in-out infinite;
}

@keyframes arrowPulse {
  0%, 100% { transform: translateX(0); }
  50% { transform: translateX(5px); }
}

/* ----- МЕТА-ИНФОРМАЦИЯ (ВРЕМЯ) ----- */
.flight-meta {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 8px;
  padding: 14px 0;
  border-top: 1px solid #E5E7EB;
  border-bottom: 1px solid #E5E7EB;
  margin-bottom: 16px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #4B5563;
  padding: 8px 12px;
  background: #F9FAFB;
  border-radius: 8px;
  transition: background 0.2s;
  min-height: 40px;
}

.meta-item:hover {
  background: #F3F4F6;
}

.meta-item i {
  color: #F59E0B;
  width: 18px;
  font-size: 14px;
  text-align: center;
  flex-shrink: 0;
}

.meta-item .label {
  color: #9CA3AF;
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-right: 2px;
  display: inline;
}

.meta-item .value {
  font-weight: 500;
  color: #1F2937;
}

.meta-item .time-value {
  font-family: 'Courier New', monospace;
  font-weight: 600;
}

.meta-item .duration-value {
  font-family: 'Courier New', monospace;
  font-weight: 600;
  color: #10B981;
}

/* Специальные стили для времени */
.meta-item.time-departure i {
  color: #1E3A8A;
}

.meta-item.time-arrival i {
  color: #F59E0B;
}

.meta-item.duration i {
  color: #10B981;
}

/* ----- КАРТА ----- */
.flight-map-container {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #E5E7EB;
  margin-bottom: 16px;
  position: relative;
  background: #F8FAFC;
  width: 100%;
}

.flight-map {
  width: 100%;
  height: 300px;
  min-height: 200px;
  position: relative;
}

/* Стили для OpenLayers поверх карты */
.flight-map .ol-zoom {
  right: 12px;
  left: auto;
  top: 12px;
}

.flight-map .ol-zoom button {
  background: white;
  color: #1E3A8A;
  border-radius: 4px;
  border: 1px solid #E5E7EB;
  font-size: 16px;
  font-weight: 700;
  transition: all 0.2s;
  width: 32px;
  height: 32px;
}

.flight-map .ol-zoom button:hover {
  background: #1E3A8A;
  color: white;
}

.flight-map .ol-zoom button:active {
  background: #F59E0B;
  color: white;
}

.flight-map .ol-rotate {
  display: none;
}

.flight-map .ol-attribution {
  bottom: 4px;
  right: 4px;
  font-size: 9px;
}

.flight-map .ol-attribution button {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  padding: 2px 6px;
}

/* ----- КНОПКИ ДЕЙСТВИЙ ----- */
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 8px;
}

.btn-close-modal {
  padding: 10px 32px;
  background: #1E3A8A;
  color: white;
  border: none;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-close-modal:hover {
  background: #F59E0B;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
}

.btn-close-modal:active {
  transform: translateY(0);
}

/* ----- СОСТОЯНИЯ ЗАГРУЗКИ/ОШИБКИ ----- */
.modal-loading,
.modal-error {
  text-align: center;
  padding: 40px 20px;
}

.modal-loading .spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #E5E7EB;
  border-top-color: #1E3A8A;
  border-right-color: #F59E0B;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: 0 auto 15px;
}

.modal-loading p {
  color: #6B7280;
  font-size: 14px;
  margin: 0;
}

.modal-error i {
  font-size: 40px;
  color: #DC2626;
  margin-bottom: 12px;
}

.modal-error p {
  color: #4B5563;
  font-size: 14px;
  margin-bottom: 16px;
}

/* ----- АНИМАЦИИ ----- */
@keyframes modalFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes modalSlideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ----- СКРОЛЛБАР ----- */
.modal-content::-webkit-scrollbar {
  width: 6px;
}

.modal-content::-webkit-scrollbar-track {
  background: #F3F4F6;
  border-radius: 3px;
}

.modal-content::-webkit-scrollbar-thumb {
  background: #D1D5DB;
  border-radius: 3px;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background: #9CA3AF;
}

/* ============================================
   АДАПТИВНОСТЬ - ПЛАНШЕТЫ
   ============================================ */
@media (max-width: 768px) {
  .modal-content {
    padding: 18px;
    border-radius: 16px;
    max-height: 98vh;
  }

  .modal-close {
    top: 12px;
    right: 12px;
    width: 44px;
    height: 44px;
    font-size: 26px;
  }

  .flight-details-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding-bottom: 12px;
  }

  .flight-number .value {
    font-size: 22px;
  }

  .flight-route-info {
    padding: 14px 16px;
    gap: 8px;
  }

  .airport-info .airport-code {
    font-size: 20px;
  }

  .airport-info .airport-city {
    font-size: 14px;
  }

  .airport-info .airport-name {
    font-size: 11px;
  }

  .flight-meta {
    grid-template-columns: 1fr 1fr;
    gap: 6px;
    padding: 10px 0;
  }

  .meta-item {
    font-size: 12px;
    padding: 6px 10px;
    min-height: 36px;
  }

  .meta-item i {
    font-size: 13px;
    width: 16px;
  }

  .flight-map {
    height: 250px;
    min-height: 180px;
  }

  .status-badge {
    font-size: 11px;
    padding: 4px 14px;
  }

  .btn-close-modal {
    padding: 8px 28px;
    font-size: 13px;
  }
}

/* ============================================
   АДАПТИВНОСТЬ - МОБИЛЬНЫЕ ТЕЛЕФОНЫ
   ============================================ */
@media (max-width: 480px) {
  .modal-overlay {
    padding: 6px;
  }

  .modal-content {
    padding: 14px;
    border-radius: 14px;
    max-height: 98vh;
  }

  .modal-close {
    top: 10px;
    right: 10px;
    width: 40px;
    height: 40px;
    font-size: 22px;
  }

  .flight-number .value {
    font-size: 20px;
  }

  .flight-route-info {
    flex-direction: column;
    padding: 12px;
    gap: 6px;
  }

  .airport-info {
    padding: 4px 0;
  }

  .airport-info .airport-code {
    font-size: 18px;
  }

  .airport-info .airport-city {
    font-size: 13px;
  }

  .airport-info .airport-name {
    font-size: 11px;
  }

  .airport-info .airport-label {
    font-size: 9px;
  }

  .route-arrow {
    flex-direction: row;
    padding: 4px 0;
    font-size: 18px;
    transform: none;
  }

  .route-arrow .distance {
    margin-top: 0;
    margin-left: 8px;
    font-size: 10px;
  }

  .route-arrow i {
    animation: none;
  }

  .flight-meta {
    grid-template-columns: 1fr 1fr;
    gap: 4px;
    padding: 8px 0;
  }

  .meta-item {
    font-size: 11px;
    padding: 5px 8px;
    min-height: 32px;
    gap: 6px;
  }

  .meta-item i {
    font-size: 12px;
    width: 14px;
  }

  .meta-item .label {
    font-size: 8px;
  }

  .flight-map {
    height: 200px;
    min-height: 150px;
  }

  .status-badge {
    font-size: 10px;
    padding: 3px 12px;
  }

  .btn-close-modal {
    padding: 8px 20px;
    font-size: 12px;
    width: 100%;
  }

  .modal-actions {
    flex-direction: column;
  }

  .modal-loading,
  .modal-error {
    padding: 30px 15px;
  }

  .modal-loading .spinner {
    width: 32px;
    height: 32px;
  }

  .modal-error i {
    font-size: 32px;
  }
}

/* ============================================
   АДАПТИВНОСТЬ - ОЧЕНЬ МАЛЕНЬКИЕ ЭКРАНЫ
   ============================================ */
@media (max-width: 360px) {
  .modal-content {
    padding: 10px;
    border-radius: 12px;
  }

  .modal-close {
    top: 8px;
    right: 8px;
    width: 36px;
    height: 36px;
    font-size: 20px;
  }

  .flight-number .value {
    font-size: 18px;
  }

  .airport-info .airport-code {
    font-size: 16px;
  }

  .airport-info .airport-city {
    font-size: 12px;
  }

  .flight-meta {
    grid-template-columns: 1fr;
    gap: 4px;
  }

  .meta-item {
    font-size: 10px;
    padding: 4px 6px;
    min-height: 28px;
  }

  .meta-item i {
    font-size: 11px;
    width: 12px;
  }

  .flight-map {
    height: 160px;
    min-height: 120px;
  }

  .btn-close-modal {
    padding: 6px 16px;
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./react/components/FlightDetails.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA,wEAAwE;AACxE;EACE,aAAa;AACf;;AAEA,yDAAyD;AACzD;EACE,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,yCAAyC;EACzC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,0BAA0B,EAAE;AACpC;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,0CAA0C;AAC1C;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,0BAA0B;AAC1B;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;iDAEiD;AACjD;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":["/* ============================================\n   FLIGHT DETAILS MODAL - ПОЛНЫЙ CSS\n   Pulkovo Air - Культурные крылья России\n   ============================================ */\n\n/* ----- МОДАЛЬНОЕ ОКНО ----- */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(4px);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: modalFadeIn 0.3s ease;\n  padding: 10px;\n}\n\n.modal-content {\n  background: #ffffff;\n  border-radius: 20px;\n  max-width: 800px;\n  width: 100%;\n  max-height: 95vh;\n  overflow-y: auto;\n  padding: 24px;\n  position: relative;\n  animation: modalSlideUp 0.3s ease;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n/* Добавляем отступ сверху для контента, чтобы не перекрывался кнопкой */\n.modal-content > *:first-child {\n  margin-top: 0;\n}\n\n/* Скрываем скролл для body при открытом модальном окне */\nbody.modal-open {\n  overflow: hidden;\n}\n\n/* ----- КНОПКА ЗАКРЫТИЯ ----- */\n.modal-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: rgba(255, 255, 255, 0.95);\n  border: none;\n  font-size: 24px;\n  color: #1E3A8A;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  z-index: 10;\n  padding: 0;\n  border-radius: 50%;\n  line-height: 1;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(4px);\n}\n\n.modal-close:hover {\n  transform: rotate(90deg) scale(1.05);\n  color: #F59E0B;\n  background: #ffffff;\n  box-shadow: 0 4px 16px rgba(245, 158, 11, 0.2);\n}\n\n.modal-close:active {\n  transform: scale(0.9);\n}\n\n/* ----- ЗАГОЛОВОК ----- */\n.flight-details-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 16px;\n  border-bottom: 2px solid #E5E7EB;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.flight-number .label {\n  font-size: 11px;\n  color: #6B7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  display: block;\n  margin-bottom: 2px;\n}\n\n.flight-number .value {\n  font-size: 26px;\n  font-weight: 700;\n  color: #1E3A8A;\n  font-family: 'Courier New', monospace;\n}\n\n.flight-status {\n  flex-shrink: 0;\n}\n\n/* ----- СТАТУСЫ ----- */\n.status-badge {\n  padding: 5px 16px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  display: inline-block;\n}\n\n.status-badge.in_air,\n.status-badge.in-air {\n  background: #FEF3E8;\n  color: #F59E0B;\n  border: 1px solid #FDE68A;\n}\n\n.status-badge.booked {\n  background: #EFF6FF;\n  color: #1E3A8A;\n  border: 1px solid #BFDBFE;\n}\n\n.status-badge.completed {\n  background: #D1FAE5;\n  color: #10B981;\n  border: 1px solid #A7F3D0;\n}\n\n.status-badge.scheduled {\n  background: #F3F4F6;\n  color: #6B7280;\n  border: 1px solid #E5E7EB;\n}\n\n.status-badge.delayed {\n  background: #FEF2F2;\n  color: #DC2626;\n  border: 1px solid #FECACA;\n}\n\n.status-badge.cancelled {\n  background: #F3F4F6;\n  color: #6B7280;\n  border: 1px solid #E5E7EB;\n  text-decoration: line-through;\n}\n\n/* ----- ИНФОРМАЦИЯ О МАРШРУТЕ ----- */\n.flight-route-info {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background: #F9FAFB;\n  border-radius: 16px;\n  margin-bottom: 16px;\n  border: 1px solid #E5E7EB;\n  gap: 10px;\n}\n\n.airport-info {\n  flex: 1;\n  text-align: center;\n}\n\n.airport-info .airport-code {\n  font-size: 22px;\n  font-weight: 700;\n  color: #1E3A8A;\n  font-family: 'Courier New', monospace;\n  letter-spacing: 1px;\n}\n\n.airport-info .airport-city {\n  font-size: 15px;\n  font-weight: 600;\n  color: #1F2937;\n  margin-top: 2px;\n}\n\n.airport-info .airport-name {\n  font-size: 12px;\n  color: #6B7280;\n  margin-top: 2px;\n}\n\n.airport-info .airport-label {\n  font-size: 10px;\n  color: #9CA3AF;\n  margin-top: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n}\n\n.airport-info.departure .airport-code {\n  color: #1E3A8A;\n}\n\n.airport-info.arrival .airport-code {\n  color: #F59E0B;\n}\n\n.route-arrow {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 15px;\n  color: #F59E0B;\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.route-arrow .distance {\n  font-size: 11px;\n  color: #6B7280;\n  margin-top: 2px;\n  font-weight: 500;\n}\n\n.route-arrow i {\n  animation: arrowPulse 2s ease-in-out infinite;\n}\n\n@keyframes arrowPulse {\n  0%, 100% { transform: translateX(0); }\n  50% { transform: translateX(5px); }\n}\n\n/* ----- МЕТА-ИНФОРМАЦИЯ (ВРЕМЯ) ----- */\n.flight-meta {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 8px;\n  padding: 14px 0;\n  border-top: 1px solid #E5E7EB;\n  border-bottom: 1px solid #E5E7EB;\n  margin-bottom: 16px;\n}\n\n.meta-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #4B5563;\n  padding: 8px 12px;\n  background: #F9FAFB;\n  border-radius: 8px;\n  transition: background 0.2s;\n  min-height: 40px;\n}\n\n.meta-item:hover {\n  background: #F3F4F6;\n}\n\n.meta-item i {\n  color: #F59E0B;\n  width: 18px;\n  font-size: 14px;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.meta-item .label {\n  color: #9CA3AF;\n  font-size: 9px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  margin-right: 2px;\n  display: inline;\n}\n\n.meta-item .value {\n  font-weight: 500;\n  color: #1F2937;\n}\n\n.meta-item .time-value {\n  font-family: 'Courier New', monospace;\n  font-weight: 600;\n}\n\n.meta-item .duration-value {\n  font-family: 'Courier New', monospace;\n  font-weight: 600;\n  color: #10B981;\n}\n\n/* Специальные стили для времени */\n.meta-item.time-departure i {\n  color: #1E3A8A;\n}\n\n.meta-item.time-arrival i {\n  color: #F59E0B;\n}\n\n.meta-item.duration i {\n  color: #10B981;\n}\n\n/* ----- КАРТА ----- */\n.flight-map-container {\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid #E5E7EB;\n  margin-bottom: 16px;\n  position: relative;\n  background: #F8FAFC;\n  width: 100%;\n}\n\n.flight-map {\n  width: 100%;\n  height: 300px;\n  min-height: 200px;\n  position: relative;\n}\n\n/* Стили для OpenLayers поверх карты */\n.flight-map .ol-zoom {\n  right: 12px;\n  left: auto;\n  top: 12px;\n}\n\n.flight-map .ol-zoom button {\n  background: white;\n  color: #1E3A8A;\n  border-radius: 4px;\n  border: 1px solid #E5E7EB;\n  font-size: 16px;\n  font-weight: 700;\n  transition: all 0.2s;\n  width: 32px;\n  height: 32px;\n}\n\n.flight-map .ol-zoom button:hover {\n  background: #1E3A8A;\n  color: white;\n}\n\n.flight-map .ol-zoom button:active {\n  background: #F59E0B;\n  color: white;\n}\n\n.flight-map .ol-rotate {\n  display: none;\n}\n\n.flight-map .ol-attribution {\n  bottom: 4px;\n  right: 4px;\n  font-size: 9px;\n}\n\n.flight-map .ol-attribution button {\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 4px;\n  padding: 2px 6px;\n}\n\n/* ----- КНОПКИ ДЕЙСТВИЙ ----- */\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 8px;\n}\n\n.btn-close-modal {\n  padding: 10px 32px;\n  background: #1E3A8A;\n  color: white;\n  border: none;\n  border-radius: 30px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-close-modal:hover {\n  background: #F59E0B;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);\n}\n\n.btn-close-modal:active {\n  transform: translateY(0);\n}\n\n/* ----- СОСТОЯНИЯ ЗАГРУЗКИ/ОШИБКИ ----- */\n.modal-loading,\n.modal-error {\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.modal-loading .spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #E5E7EB;\n  border-top-color: #1E3A8A;\n  border-right-color: #F59E0B;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin: 0 auto 15px;\n}\n\n.modal-loading p {\n  color: #6B7280;\n  font-size: 14px;\n  margin: 0;\n}\n\n.modal-error i {\n  font-size: 40px;\n  color: #DC2626;\n  margin-bottom: 12px;\n}\n\n.modal-error p {\n  color: #4B5563;\n  font-size: 14px;\n  margin-bottom: 16px;\n}\n\n/* ----- АНИМАЦИИ ----- */\n@keyframes modalFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes modalSlideUp {\n  from {\n    transform: translateY(30px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ----- СКРОЛЛБАР ----- */\n.modal-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.modal-content::-webkit-scrollbar-track {\n  background: #F3F4F6;\n  border-radius: 3px;\n}\n\n.modal-content::-webkit-scrollbar-thumb {\n  background: #D1D5DB;\n  border-radius: 3px;\n}\n\n.modal-content::-webkit-scrollbar-thumb:hover {\n  background: #9CA3AF;\n}\n\n/* ============================================\n   АДАПТИВНОСТЬ - ПЛАНШЕТЫ\n   ============================================ */\n@media (max-width: 768px) {\n  .modal-content {\n    padding: 18px;\n    border-radius: 16px;\n    max-height: 98vh;\n  }\n\n  .modal-close {\n    top: 12px;\n    right: 12px;\n    width: 44px;\n    height: 44px;\n    font-size: 26px;\n  }\n\n  .flight-details-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    padding-bottom: 12px;\n  }\n\n  .flight-number .value {\n    font-size: 22px;\n  }\n\n  .flight-route-info {\n    padding: 14px 16px;\n    gap: 8px;\n  }\n\n  .airport-info .airport-code {\n    font-size: 20px;\n  }\n\n  .airport-info .airport-city {\n    font-size: 14px;\n  }\n\n  .airport-info .airport-name {\n    font-size: 11px;\n  }\n\n  .flight-meta {\n    grid-template-columns: 1fr 1fr;\n    gap: 6px;\n    padding: 10px 0;\n  }\n\n  .meta-item {\n    font-size: 12px;\n    padding: 6px 10px;\n    min-height: 36px;\n  }\n\n  .meta-item i {\n    font-size: 13px;\n    width: 16px;\n  }\n\n  .flight-map {\n    height: 250px;\n    min-height: 180px;\n  }\n\n  .status-badge {\n    font-size: 11px;\n    padding: 4px 14px;\n  }\n\n  .btn-close-modal {\n    padding: 8px 28px;\n    font-size: 13px;\n  }\n}\n\n/* ============================================\n   АДАПТИВНОСТЬ - МОБИЛЬНЫЕ ТЕЛЕФОНЫ\n   ============================================ */\n@media (max-width: 480px) {\n  .modal-overlay {\n    padding: 6px;\n  }\n\n  .modal-content {\n    padding: 14px;\n    border-radius: 14px;\n    max-height: 98vh;\n  }\n\n  .modal-close {\n    top: 10px;\n    right: 10px;\n    width: 40px;\n    height: 40px;\n    font-size: 22px;\n  }\n\n  .flight-number .value {\n    font-size: 20px;\n  }\n\n  .flight-route-info {\n    flex-direction: column;\n    padding: 12px;\n    gap: 6px;\n  }\n\n  .airport-info {\n    padding: 4px 0;\n  }\n\n  .airport-info .airport-code {\n    font-size: 18px;\n  }\n\n  .airport-info .airport-city {\n    font-size: 13px;\n  }\n\n  .airport-info .airport-name {\n    font-size: 11px;\n  }\n\n  .airport-info .airport-label {\n    font-size: 9px;\n  }\n\n  .route-arrow {\n    flex-direction: row;\n    padding: 4px 0;\n    font-size: 18px;\n    transform: none;\n  }\n\n  .route-arrow .distance {\n    margin-top: 0;\n    margin-left: 8px;\n    font-size: 10px;\n  }\n\n  .route-arrow i {\n    animation: none;\n  }\n\n  .flight-meta {\n    grid-template-columns: 1fr 1fr;\n    gap: 4px;\n    padding: 8px 0;\n  }\n\n  .meta-item {\n    font-size: 11px;\n    padding: 5px 8px;\n    min-height: 32px;\n    gap: 6px;\n  }\n\n  .meta-item i {\n    font-size: 12px;\n    width: 14px;\n  }\n\n  .meta-item .label {\n    font-size: 8px;\n  }\n\n  .flight-map {\n    height: 200px;\n    min-height: 150px;\n  }\n\n  .status-badge {\n    font-size: 10px;\n    padding: 3px 12px;\n  }\n\n  .btn-close-modal {\n    padding: 8px 20px;\n    font-size: 12px;\n    width: 100%;\n  }\n\n  .modal-actions {\n    flex-direction: column;\n  }\n\n  .modal-loading,\n  .modal-error {\n    padding: 30px 15px;\n  }\n\n  .modal-loading .spinner {\n    width: 32px;\n    height: 32px;\n  }\n\n  .modal-error i {\n    font-size: 32px;\n  }\n}\n\n/* ============================================\n   АДАПТИВНОСТЬ - ОЧЕНЬ МАЛЕНЬКИЕ ЭКРАНЫ\n   ============================================ */\n@media (max-width: 360px) {\n  .modal-content {\n    padding: 10px;\n    border-radius: 12px;\n  }\n\n  .modal-close {\n    top: 8px;\n    right: 8px;\n    width: 36px;\n    height: 36px;\n    font-size: 20px;\n  }\n\n  .flight-number .value {\n    font-size: 18px;\n  }\n\n  .airport-info .airport-code {\n    font-size: 16px;\n  }\n\n  .airport-info .airport-city {\n    font-size: 12px;\n  }\n\n  .flight-meta {\n    grid-template-columns: 1fr;\n    gap: 4px;\n  }\n\n  .meta-item {\n    font-size: 10px;\n    padding: 4px 6px;\n    min-height: 28px;\n  }\n\n  .meta-item i {\n    font-size: 11px;\n    width: 12px;\n  }\n\n  .flight-map {\n    height: 160px;\n    min-height: 120px;\n  }\n\n  .btn-close-modal {\n    padding: 6px 16px;\n    font-size: 11px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
